/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconUserShare = createReactComponent("user-share", "IconUserShare", [
  ["path", { d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", key: "svg-0" }],
  ["path", { d: "M6 21v-2a4 4 0 0 1 4 -4h3", key: "svg-1" }],
  ["path", { d: "M16 22l5 -5", key: "svg-2" }],
  ["path", { d: "M21 21.5v-4.5h-4.5", key: "svg-3" }]
]);

export { IconUserShare as default };
//# sourceMappingURL=IconUserShare.js.map
